import { call, put, select, takeLatest } from 'redux-saga/effects'
import { getServiceIdSelector } from '../../user/selectors'
import { CrewService } from '../../crew/services/crew.service'
import { throwPcrException } from '../../pcr/store/pcr.actions'
import { ICrewList } from '../../pcr/models/crewList.V1'
import { ClientDataConstants } from '../../clientData/store/clientData.constants'
import { setClinicalUserList } from '../store/completeChart.actions'
import { performWithMutexHOG } from '../../../services/mutexUtility.service'
import { CrewConstants } from '../../crew/store/crew.constants'
import { HomeConstants } from '../../home/store/home.constants'
export function* getClinicalUser() {
  try {
    const serviceId: string = yield select(getServiceIdSelector)
    const crewService = new CrewService(serviceId)
    const clinicalUserList: ICrewList = yield call([crewService, crewService.getClinicalUserList])
    yield put(setClinicalUserList(clinicalUserList?.entity))
  } catch (e) {
    yield put(throwPcrException(`getClinicalUser() error: ${e}`))
  }
}
export function* getClinicalUserSaga() {
  yield takeLatest(
    [ClientDataConstants.ON_CLIENT_DATA_IMPORT_SUCCESS, CrewConstants.SET_CREW_LIST, HomeConstants.GET_ALL_PCR_DOCS],
    performWithMutexHOG,
    getClinicalUser
  )
}
